import { PerformanceLog } from './performance-log.decorator';

/**
 * MethodPerformanceLog is a method decorator factory
 * It returns a method decorator
 *
 * The returned decorator will wrap the original method
 * and log initial timestamp, final timestamp and execution duration of the method
 *
 * It will also consider if the returned value is a Promise
 * and register for the Promise resolution
 *
 * It does not handle erros or promises rejected
 */
export function MethodPerformanceLog(countExecution = false, name?: string): MethodDecorator {
  return PerformanceLog('MethodPerformanceLog', false, countExecution, name);
}
